/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  BulkUpdateDealReportsMutationRequest,
  BulkUpdateDealReportsMutationResponse,
  BulkUpdateDealReports400,
} from '../types/BulkUpdateDealReports'

function getBulkUpdateDealReportsUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/reports/deals/bulk/update/` as const,
  }
  return res
}

/**
 * @description Handle bulk update of deals.
 * @summary Bulk update deals from the deal-reports table
 * {@link /api/v1/reports/deals/bulk/update/}
 */
export async function bulkUpdateDealReports(
  data: BulkUpdateDealReportsMutationRequest,
  config: Partial<RequestConfig<BulkUpdateDealReportsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    BulkUpdateDealReportsMutationResponse,
    ResponseErrorConfig<BulkUpdateDealReports400>,
    BulkUpdateDealReportsMutationRequest
  >({
    method: 'POST',
    url: getBulkUpdateDealReportsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
